import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["v-model"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", {
    class: "option",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editBookmark && _ctx.editBookmark(...args))),
    "v-model": _ctx.bookmark
  }, [
    _createElementVNode("button", null, [
      _createVNode(_component_font_awesome_icon, {
        class: "margin__right__10",
        icon: _ctx.icon
      }, null, 8, ["icon"]),
      _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
    ])
  ], 8, _hoisted_1))
}